import * as React from 'react';
import { cn } from '@/lib/utils';

type Varyant = 'birincil' | 'ikincil' | 'sessiz' | 'tehlike' | 'basari';
type Boyut = 'sm' | 'md' | 'lg' | 'xl';

const VARYANTLAR: Record<Varyant, string> = {
  birincil: 'bg-marka-600 text-white hover:bg-marka-700 focus-visible:ring-marka-500',
  ikincil: 'bg-white text-slate-900 border border-slate-300 hover:bg-slate-50 focus-visible:ring-slate-400',
  sessiz: 'bg-transparent text-slate-700 hover:bg-slate-100 focus-visible:ring-slate-300',
  tehlike: 'bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500',
  basari: 'bg-emerald-600 text-white hover:bg-emerald-700 focus-visible:ring-emerald-500',
};

// Resepsiyon tableti: varsayilan buton yuksekligi 48px (parmakla rahat)
const BOYUTLAR: Record<Boyut, string> = {
  sm: 'h-9 px-3 text-sm',
  md: 'h-11 px-4 text-base',
  lg: 'h-14 px-6 text-lg',
  xl: 'h-16 px-8 text-xl',
};

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  varyant?: Varyant;
  boyut?: Boyut;
  yukleniyor?: boolean;
  kisayol?: string;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, varyant = 'birincil', boyut = 'md', yukleniyor, kisayol, children, disabled, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      disabled={disabled || yukleniyor}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-xl font-medium transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
        'disabled:pointer-events-none disabled:opacity-50',
        VARYANTLAR[varyant],
        BOYUTLAR[boyut],
        className,
      )}
      {...props}
    >
      {yukleniyor && (
        <span
          aria-hidden
          className="size-4 animate-spin rounded-full border-2 border-current border-t-transparent"
        />
      )}
      {children}
      {kisayol && (
        <kbd className="ml-1 rounded border border-current/30 px-1.5 py-0.5 text-xs opacity-70">{kisayol}</kbd>
      )}
    </button>
  );
});
